// extracted by mini-css-extract-plugin
export default {"root":"QaRibjgTIR","layout":"Cao5DyvkV_","content":"t0m9DOgU62","relevant":"IZdaSqC0a9","relevantTitle":"zElPIzWqQ2","host":"Lte2Ca39Tb"};